import { ScrollStrategy, ScrollStrategyOptions } from "@angular/cdk/overlay";
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, TemplateRef } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { forkJoin } from "rxjs";
import { finalize } from "rxjs/operators";
import {
  CommonClient,
  DiscountTypeEnum,
  ObjectEnumOfPaymentTypeEnum,
  OrderChanelEnum,
  OrderCustomerClient,
  OrderCustomerModel,
  OrderCustomerStatusEnum,
  OrderItemCustomerModel,
  OrderTypeEnum,
  PaymentTypeEnum,
  ProductDto,
  OrderCustomerTypeEnum,
  ObjectEnumOfOrderCustomerTypeEnum,
} from "src/app/shared/api-connector/sso-connector";
import { AuthService } from "src/app/shared/services/auth.service";
import { DrawerService } from "src/app/shared/components/drawer/drawer.service";
import { AddCustomerDrawerComponent } from "../add-customer-drawer/add-customer-drawer.component";
import { PrintInvoicePdf } from "../../shared/model/invoice-print";
import { PopupService, PopupRef } from "@progress/kendo-angular-popup";
import { AlertService } from "src/app/shared/services/alert.service";
import * as moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { EventEmitterService } from "src/app/shared/services/event.emitter.service";
import { CURRENCY_MASK_CONFIG } from "../../shared/constants/currency-mask.config";
import { formatDateTimeZone } from "src/app/shared/functions";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: "app-order-content-dynamic",
  templateUrl: "./order-content-dynamic.component.html",
  styleUrls: ["./order-content-dynamic.component.scss"],
})
export class OrderContentDynamicComponent implements OnInit {
  @Input() active = false;
  @Input() orderCustomerModel: OrderCustomerModel;
  // @Input() orderCustomerModel: TabOrderValue<OrderCustomerModel>;
  lstProduct: OrderItemCustomerModel[] = [];
  reloadCustomerComponent: any;
  phoneNumber: string = "";
  scrollStrategy: ScrollStrategy | null = null;
  date = "";
  accountCtrl = new FormControl("");
  customerCtrl = new FormControl("");
  paymentTypeCtrl = new FormControl(0);
  orderCustomerTypeEnumCtrl = new FormControl(OrderCustomerTypeEnum.BAN_LE);
  createByTimeCtrl = new FormControl(false); // Checkbox "Hóa đơn theo giờ"
  orderDateCtrl = new FormControl(formatDateTimeZone(new Date())); // Editable date/time
  lstPaymentType: ObjectEnumOfPaymentTypeEnum[] = [];
  lstOrderCustomerTypeEnum: ObjectEnumOfOrderCustomerTypeEnum[] = [];
  activeDiscountTypeVND: boolean = true;
  activeDiscountTypePercent: boolean = false;
  private popupDetailMore: PopupRef | null = null;
  private popupRefDiscountCart: PopupRef | null = null;
  private popupRefDiscountItemCart: PopupRef | null = null;
  isShowChangeAmount: boolean = false;
  isInvoiceByTime: boolean = false;
  isShowPaymentMobile: boolean = false; // Added for mobile responsiveness

  readonly currencyMaskConfig = CURRENCY_MASK_CONFIG;

  get discountOptions() {
    return {
      ...CURRENCY_MASK_CONFIG.VN_MONEY,
      precision: this.activeDiscountTypePercent ? 3 : 0,
    };
  }

  getPaymentIcon(value: number) {
    if (value === 0) return "fa-money";
    if (value === 1) return "fa-credit-card";
    if (value === 2) return "fa-bank";
    return "";
  }

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
    private readonly scrollStrategyOptions: ScrollStrategyOptions,
    private elementRef: ElementRef,
    private alertService: AlertService,
    private orderCustomerClient: OrderCustomerClient,
    private spinner: NgxSpinnerService,
    private commomClient: CommonClient,
    private popupService: PopupService,
    private drawerService: DrawerService,
    private cdr: ChangeDetectorRef
  ) {
    // this.setInvoiceDefault();
    this.date = this.toDateString(new Date());
    this.getDataFields();
  }

  ngOnInit(): void {
    this.scrollStrategy = this.scrollStrategyOptions.noop();
    this.accountCtrl.setValue(this.authService.getAccount());

    this.orderCustomerTypeEnumCtrl?.valueChanges.subscribe((type) => {
      if (type === OrderCustomerTypeEnum.DONG_DON) {
        // Gán giá trị 1000 cho payingAmtInvoice
        this.orderCustomerModel.payingAmtInvoice = 1000;
      } else {
        this.orderCustomerModel.payingAmtInvoice =
          this.orderCustomerModel.orderTotal;
      }
    });
  }

  generatePDF(invoice: PrintInvoicePdf) {
    const body: any[] = [
      [
        { text: "S.Phẩm", style: "tableHeader" },
        { text: "Đ.Giá", style: "tableHeader" },
        { text: "SL", style: "tableHeader" },
        { text: "T.Tiền", style: "tableHeader" },
      ],
    ];

    if (this.orderCustomerModel.orderItemCustomers) {
      this.orderCustomerModel.orderItemCustomers.forEach(
        (x: OrderItemCustomerModel) => {
          let orderItem = [];
          // xử lý colSpan productName
          orderItem.push({
            colSpan: 4,
            text: `${x.productName} (${x.productUnitName})`,
            bold: true,
          });
          orderItem.push("");
          orderItem.push("");
          orderItem.push("");
          body.push(orderItem);

          // Xử lý data table còn lại
          orderItem = [];
          orderItem.push("");
          orderItem.push(
            Intl.NumberFormat("vi-VN", {
              style: "currency",
              currency: "VND",
            }).format(x.adjustedPrice),
          );
          orderItem.push(x.quantity);
          orderItem.push(
            Intl.NumberFormat("vi-VN", {
              style: "currency",
              currency: "VND",
            }).format(x.adjustedPrice * x.quantity),
          );
          body.push(orderItem);
        },
      );
    }
    const bodyInfo = [
      [
        { colSpan: 2, text: "Tổng số lượng" },
        "",
        `${invoice.orderTotalQty}`,
        "",
      ],
      [
        { colSpan: 3, text: "Tổng tiền hàng" },
        "",
        "",
        `${Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
        }).format(invoice.orderTotal)}`,
      ],
      [
        { colSpan: 3, text: "Giảm giá" },
        "",
        "",
        `${Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
        }).format(invoice.discount)}`,
      ],
      [
        { colSpan: 3, text: "Khách cần trả" },
        "",
        "",
        `${Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
        }).format(invoice.orderTotal - invoice.discount)}`,
      ],
      [
        { colSpan: 3, text: "Khách đưa tiền" },
        "",
        "",
        `${Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
        }).format(invoice.payingAmtInvoice)}`,
      ],
      [
        { colSpan: 3, text: "Trả tiền thừa" },
        "",
        "",
        `${Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
        }).format(invoice.payingAmtInvoice - invoice.orderTotal)}`,
      ],
    ];

    const docDefinition = {
      content: [
        {
          alignment: "center",
          columns: [
            {
              text: "Phạm Dương Quầy 539",
              fontSize: 14,
              bold: true,
            },
          ],
        },
        {
          alignment: "center",
          columns: [
            {
              text: "HÓA ĐƠN BÁN HÀNG",
              fontSize: 12,
              marginTop: 10,
            },
          ],
        },
        {
          text: `${invoice.sellerName} : ${invoice.time}`,
          fontSize: 10,
        },
        {
          text: `KH : ${invoice.customerName}`,
          fontSize: 10,
        },
        {
          text: `SĐT : ${this.phoneNumber}`,
          fontSize: 10,
        },
        // table data
        {
          style: "tableExample",
          table: {
            widths: ["*", "*", 20, "*"],
            headerRows: 1,
            body: body,
          },
          layout: "noBorders",
        },

        {
          style: "tableExample",
          table: {
            widths: ["*", "*", 20, "*"],
            headerRows: 1,
            body: bodyInfo,
          },
          layout: "noBorders",
        },
        { text: `Số hóa đơn : ${invoice.code}`, fontSize: 10 },
        { text: `Thanh toán bằng : ${invoice.paymentType}`, fontSize: 10 },
        {
          text: "CÁM ƠN QUÝ KHÁCH VÀ HẸN GẶP LẠI",
          style: "subheader",
        },
      ],
      defaultStyle: {
        columnGap: 10,
      },
      pageMargins: [5, 10, 5, 0], // Set all margins to 0 (left, top, right, bottom)
      styles: {
        header: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
          alignment: "left",
        },
        subheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 10, 0, 5],
          alignment: "center",
        },
        tableExample: {
          margin: [0, 5, 2, 5],
          fontSize: 10,
          width: 213,
        },
        tableHeader: {
          bold: true,
          fontSize: 12,
          color: "black",
        },
      },
      pageSize: {
        width: 213,
        height: "auto",
      },
    };

    pdfMake.createPdf(docDefinition).print();
  }

  openDiscount(event: any, template: TemplateRef<any>) {
    if (this.popupRefDiscountCart) {
      this.popupRefDiscountCart.close();
      this.popupRefDiscountCart = null;
    } else {
      this.popupRefDiscountCart = this.popupService.open({
        content: template,
        offset: { top: event.y - 30, left: 1503 },
      });
    }
  }

  openDiscountItem(event: any, template: TemplateRef<any>) {
    if (this.popupRefDiscountItemCart) {
      this.popupRefDiscountItemCart.close();
      this.popupRefDiscountItemCart = null;
    } else {
      this.popupRefDiscountItemCart = this.popupService.open({
        content: template,
        offset: { top: event.y + 30, left: event.x - 70 },
      });
    }
  }

  openDetailMore(event: any, template: TemplateRef<any>) {
    if (this.popupDetailMore) {
      this.popupDetailMore.close();
      this.popupDetailMore = null;
    } else {
      this.popupDetailMore = this.popupService.open({
        content: template,
        offset: { top: event.y + 20, left: 1300 },
      });
    }
  }

  public toggle(): void {
    if (this.popupRefDiscountCart) {
      this.popupRefDiscountCart.close();
      this.popupRefDiscountCart = null;
    }

    if (this.popupDetailMore) {
      this.popupDetailMore.close();
      this.popupDetailMore = null;
    }

    if (this.popupRefDiscountItemCart) {
      this.popupRefDiscountItemCart.close();
      this.popupRefDiscountItemCart = null;
    }
  }

  @HostListener("document:keydown", ["$event"])
  public keydown(event: KeyboardEvent): void {
    if (event.code === "Escape") {
      this.toggle();
    }
  }

  switchDiscountType(event: any, orderCustomerModel: OrderCustomerModel) {
    var target = event.target || event.srcElement || event.currentTarget;
    if (target.id == "discountTypeVnd") {
      this.activeDiscountTypePercent = false;
      this.activeDiscountTypeVND = true;
      orderCustomerModel.discountType = DiscountTypeEnum.VND;
      if (orderCustomerModel.discount > 0) {
        orderCustomerModel.discount =
          (orderCustomerModel.discount *
            (orderCustomerModel.quantity * orderCustomerModel.price)) /
          100;
      }
    } else if (target.id == "discountTypePercent") {
      this.activeDiscountTypePercent = true;
      this.activeDiscountTypeVND = false;
      orderCustomerModel.discountType = DiscountTypeEnum.PERCENT;
      if (orderCustomerModel.discount > 0) {
        orderCustomerModel.discount =
          (orderCustomerModel.discount /
            (orderCustomerModel.quantity * orderCustomerModel.price)) *
          100;
      }
    }
  }

  activeDiscountItemTypeVND: boolean = true;
  activeDiscountItemTypePercent: boolean = false;
  switchDiscountItemType(event: any, item: OrderItemCustomerModel) {
    var target = event.target || event.srcElement || event.currentTarget;
    if (target.id == "discountItemTypeVnd") {
      this.activeDiscountItemTypePercent = false;
      this.activeDiscountItemTypeVND = true;
      item.discountType = DiscountTypeEnum.VND;
      if (item.discount > 0) {
        item.discount = (item.discount * (item.quantity * item.price)) / 100;
      }
    } else if (target.id == "discountItemTypePercent") {
      this.activeDiscountItemTypePercent = true;
      this.activeDiscountItemTypeVND = false;
      item.discountType = DiscountTypeEnum.PERCENT;
      if (item.discount > 0) {
        item.discount = (item.discount / (item.quantity * item.price)) * 100;
      }
    }
  }

  updateListPrice(
    item: ProductDto,
    changeQuantity: number = 1,
    resetQuantity: boolean = false,
  ) {
    let productsOrder = this.orderCustomerModel.orderItemCustomers.filter(
      (x: OrderItemCustomerModel) => x.productId == item.id,
    );
    // let qtyOrderByProductId = productsOrder.reduce((sum, item) => sum + Number(item.quantity), 0);

    // sub
    if (changeQuantity > 0) {
      if (item && item.lstPrice.length > 0) {
        if (resetQuantity) {
          for (let index = 0; index < item.lstPrice.length; index++) {
            const price = item.lstPrice[index];
            price.quantity = price.quantityOrigin;
          }
        }

        let index = 0;
        while (changeQuantity > 0 && index < item.lstPrice.length) {
          if (item.lstPrice[index].quantity - changeQuantity >= 0) {
            item.lstPrice[index].quantity -= changeQuantity;
            break;
          } else {
            changeQuantity -= item.lstPrice[index].quantity;
            item.lstPrice[index].quantity = 0;
            index++;
          }
        }
      }
    }
    if (changeQuantity < 0) {
      changeQuantity = -changeQuantity;
      let index = item.lstPrice.length - 1;
      while (changeQuantity > 0 && index !== -1) {
        if (
          item.lstPrice[index].quantity + changeQuantity <=
          item.lstPrice[index].quantityOrigin
        ) {
          item.lstPrice[index].quantity += changeQuantity;
          break;
        } else {
          item.lstPrice[index].quantity = item.lstPrice[index].quantityOrigin;
          changeQuantity -=
            item.lstPrice[index].quantityOrigin - item.lstPrice[index].quantity;
          index--;
        }
      }
    }

    productsOrder.forEach((x: OrderItemCustomerModel) => {
      x.productDto.lstPrice = item.lstPrice;
    });
  }

  // changeDiscountItem(event, item: OrderItemCustomerModel) {
  //   if (item.quantity <= 0) {
  //     return;
  //   }

  //   if (item.discount > 0) {
  //     item.adjustedPrice = item.unitPrice - item.discount;
  //     item.price = item.adjustedPrice * item.quantity;
  //     // item.price = item.price - item.discount;
  //   }

  //   this.bindingOrderCart();
  // }

  changeAdjustedPrice(event: any, item: OrderItemCustomerModel) {
    // Ensure quantity is a number
    item.quantity = Number(item.quantity) || 0;
    if (item.quantity < 0) {
      item.quantity = 0;
    }
    item.price = item.adjustedPrice * item.quantity;
    this.bindingOrderCart();

    this.checkIsOverInventory(item.productDto);
  }

  changeUnitPrice(event: any, item: OrderItemCustomerModel) {
    // item.adjustedPrice = item.unitPrice- item.discount;
    item.price = item.adjustedPrice * item.quantity;
    this.bindingOrderCart();
  }

  focusout(item: OrderItemCustomerModel) {
    if (!item.quantity || item.quantity == 0) {
      item.quantity = 1;
      item.price = item.adjustedPrice * item.quantity;
      this.bindingOrderCart();
    }

    let qtyOrderByProductId = this.orderCustomerModel.orderItemCustomers
      .filter((x: OrderItemCustomerModel) => x.productId == item.productId)
      .reduce((sum: number, item: OrderItemCustomerModel) => sum + Number(item.quantity), 0);

    this.updateListPrice(item.productDto, qtyOrderByProductId, true);
  }

  numberWithCommas(x: any) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  selectedProduct(item: ProductDto) {
    // console.log(item)
    if (item) {
      if (!this.orderCustomerModel.orderItemCustomers) {
        this.orderCustomerModel.orderItemCustomers = [];
      }
      this.orderCustomerModel.orderItemCustomers.unshift(
        new OrderItemCustomerModel({
          price: item.price,
          productId: item.id,
          quantity: 1,
          unitPrice: item.price,
          productCode: item.code,
          productName: item.title,
          productUnitName: item.productUnitName || "",
          isShowNoteItem: false,
          discount: 0,
          discountType: DiscountTypeEnum.VND,
          adjustedPrice: item.price,
          productDto: item,
          priceCost: item.priceCost,
          inventory: item.inventory,
        }),
      );
      let qtyOrderByProductId = this.orderCustomerModel.orderItemCustomers
        .filter((x: OrderItemCustomerModel) => x.productId == item.id)
        .reduce((sum: number, item: OrderItemCustomerModel) => sum + Number(item.quantity), 0);
      this.orderCustomerModel.quantity =
        this.orderCustomerModel.orderItemCustomers.reduce(
          (sum: number, item: OrderItemCustomerModel) => sum + Number(item.quantity),
          0,
        );
      this.orderCustomerModel.price =
        this.orderCustomerModel.orderItemCustomers.reduce(
          (sum: number, item: OrderItemCustomerModel) =>
            sum + Number(item.adjustedPrice) * Number(item.quantity),
          0,
        );
      this.orderCustomerModel.orderTotal =
        this.orderCustomerModel.price - this.orderCustomerModel.discount;
      this.orderCustomerModel.payingAmtInvoice =
        this.orderCustomerModel.orderTotal;
      // === KIỂM TRA VÀ GÁN MÀU CHỈ KHI TRÙNG ≥ 2 ===
      this.updateProductHighlightColors();
      this.checkIsOverInventory(item);
      this.updateListPrice(item, qtyOrderByProductId);
      this.bindingOrderCart();
    }
  }

  // Cập nhật màu cho các sản phẩm **có số lần xuất hiện ≥ 2**
  private updateProductHighlightColors(): void {
    // Đếm số DÒNG (entries) theo productId, không phải tổng quantity
    const productLineCountMap = new Map<string, number>();

    this.orderCustomerModel.orderItemCustomers.forEach((item: OrderItemCustomerModel) => {
      const currentCount = productLineCountMap.get(item.productId) || 0;
      productLineCountMap.set(item.productId, currentCount + 1); // đếm số lần xuất hiện (số dòng)
    });

    // Tạo Map màu mới hoàn toàn để Angular detect change
    const newColorMap = new Map<string, string>();

    productLineCountMap.forEach((lineCount, productId) => {
      if (lineCount >= 2) {
        newColorMap.set(productId, this.getDistinctColor(productId));
      }
      // Nếu < 2 → không set → sẽ không có trong map → get() trả về undefined → transparent
    });

    // Gán reference mới → trigger change detection 100%
    this.productColorMap = newColorMap;
  }

  private getDistinctColor(id: string): string {
    // Dùng thuật toán hash đơn giản để tạo màu cố định
    let hash = 0;
    const str = id.toString();
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Tạo HSL color: Hue đa dạng, Saturation cao, Lightness vừa phải
    const hue = Math.abs(hash % 360);
    const saturation = 70 + (hash % 20); // 70-90%
    const lightness = 50 + (hash % 15); // 50-65% → không quá sáng/chìm

    return `hsl(${hue}, ${saturation}%, ${lightness}%, 0.3)`;
  }

  calculateItemAverageBatchPrice(item: OrderItemCustomerModel, previousQty: number): number {
    const productDto = item.productDto;
    if (!productDto || !productDto.lstPrice || productDto.lstPrice.length === 0) {
      return item.unitPrice || 0;
    }

    const currentQty = Number(item.quantity) || 0;
    if (currentQty <= 0) return 0;

    let totalCost = 0;
    let qtyLeftToCover = currentQty;
    let cumulativeBatchQty = 0;

    for (const batch of productDto.lstPrice) {
      const batchQty = Number(batch.quantityOrigin) || 0;
      const batchPrice = Number(batch.price) || 0;

      // Tính toán đoạn giao nhau giữa các lô hàng và vị trí sản phẩm trong giỏ hàng
      const batchStart = cumulativeBatchQty;
      const batchEnd = cumulativeBatchQty + batchQty;

      const rowStart = previousQty;
      const rowEnd = previousQty + currentQty;

      const overlapStart = Math.max(batchStart, rowStart);
      const overlapEnd = Math.min(batchEnd, rowEnd);

      if (overlapEnd > overlapStart) {
        const qtyFromThisBatch = overlapEnd - overlapStart;
        totalCost += qtyFromThisBatch * batchPrice;
        qtyLeftToCover -= qtyFromThisBatch;
      }

      cumulativeBatchQty = batchEnd;
      if (qtyLeftToCover <= 0) break;
    }

    // Nếu số lượng vượt quá tồn kho (over inventory), dùng giá của lô cuối cùng cho phần dư
    if (qtyLeftToCover > 0 && productDto.lstPrice.length > 0) {
      const lastBatchPrice = productDto.lstPrice[productDto.lstPrice.length - 1].price;
      totalCost += qtyLeftToCover * lastBatchPrice;
    }

    return totalCost / currentQty;
  }

  updateAllAverageBatchPrices() {
    if (!this.orderCustomerModel || !this.orderCustomerModel.orderItemCustomers) return;

    const productQtyMap = new Map<string, number>();

    this.orderCustomerModel.orderItemCustomers.forEach((item) => {
      const productId = item.productId;
      const previousQty = productQtyMap.get(productId) || 0;

      const avgPrice = this.calculateItemAverageBatchPrice(item, previousQty);
      (item as any).avgBatchPrice = avgPrice;

      productQtyMap.set(productId, previousQty + Number(item.quantity || 0));
    });
  }

  isProductDuplicated(productId: string): boolean {
    return this.productColorMap.has(productId);
  }

  // Map để lưu màu nền theo productId
  private productColorMap: Map<string, string> = new Map();

  getProductColor(productId: string): string {
    return this.productColorMap.get(productId) || "transparent";
  }

  // Optional: trackBy để tối ưu *ngFor
  trackByProductId(index: number, item: OrderItemCustomerModel): any {
    return item.productId + "_" + item.quantity;
  }

  private checkIsOverInventory(item: ProductDto) {
    let qtyP = item.lstPrice.reduce(
      (sum: number, itemP: any) => sum + Number(itemP.quantityOrigin),
      0,
    );
    let qtyO = this.orderCustomerModel.orderItemCustomers
      .filter((x: OrderItemCustomerModel) => x.productId == item.id)
      .reduce((sum: number, itemO: OrderItemCustomerModel) => sum + Number(itemO.quantity), 0);
    let isOverInventory = qtyP < qtyO;
    this.orderCustomerModel.orderItemCustomers
      .filter((x: OrderItemCustomerModel) => x.productId == item.id)
      .forEach((z: OrderItemCustomerModel) => {
        z.productDto.isOverInventory = isOverInventory;
      });
  }

  moveElementWithCondition<T>(
    array: T[],
    condition: (item: T) => boolean,
    newIndex: number,
  ) {
    const indexToMove = array.findIndex(condition);

    if (indexToMove !== -1) {
      const [movedElement] = array.splice(indexToMove, 1);
      array.splice(newIndex, 0, movedElement);
    }
  }

  changeDiscount(event: any) {
    if (this.orderCustomerModel.quantity <= 0) {
      return;
    }

    let orderOrtotal = this.orderCustomerModel.orderItemCustomers.reduce(
      (sum: number, item: OrderItemCustomerModel) => sum + Number(item.price),
      0,
    );
    if (this.orderCustomerModel.discount > orderOrtotal) {
      this.orderCustomerModel.discount = 0;
    }

    this.bindingOrderCart();
  }

  bindingOrderCart() {
    let orderOrtotal = this.orderCustomerModel.orderItemCustomers.reduce(
      (sum: number, item: OrderItemCustomerModel) => sum + Number(item.price),
      0,
    );
    let orderQuantity = this.orderCustomerModel.orderItemCustomers.reduce(
      (sum: number, item: OrderItemCustomerModel) => sum + Number(item.quantity),
      0,
    );
    if (this.orderCustomerModel.discount > orderOrtotal) {
      return;
    }
    this.orderCustomerModel.price = orderOrtotal;
    this.orderCustomerModel.orderTotal =
      orderOrtotal - this.orderCustomerModel.discount;
    this.orderCustomerModel.quantity = orderQuantity;
    this.orderCustomerModel.payingAmtInvoice =
      this.orderCustomerModel.orderTotal;

    this.updateAllAverageBatchPrices();
  }

  removeItem(orderItem: OrderItemCustomerModel) {
    const indexTotal = this.orderCustomerModel.orderItemCustomers.indexOf(
      orderItem,
      0,
    );
    if (indexTotal > -1) {
      this.orderCustomerModel.orderItemCustomers.splice(indexTotal, 1);
    }
    let qtyOrderByProductId = this.orderCustomerModel.orderItemCustomers
      .filter((x: OrderItemCustomerModel) => x.productId == orderItem.productId)
      .reduce((sum: number, item: any) => sum + Number(item.quantity), 0);

    this.updateListPrice(orderItem.productDto, qtyOrderByProductId, true);
    this.checkIsOverInventory(orderItem.productDto);
    this.bindingOrderCart();
    this.updateProductHighlightColors();
  }

  getDataFields() {
    forkJoin([
      this.commomClient.getPaymentTypeEnum(),
      this.commomClient.getListOrderCustomerTypeEnum(),
    ]).subscribe((x) => {
      this.lstPaymentType = x[0] as unknown as ObjectEnumOfPaymentTypeEnum[];
      this.lstOrderCustomerTypeEnum =
        x[1] as unknown as ObjectEnumOfOrderCustomerTypeEnum[];
    });
  }
  addProductIndex = 0;
  quantity = 0;
  updateItemCart(key: any, orderItem: OrderItemCustomerModel) {
    let changeQuantity;
    // Ensure quantity is a number to prevent string concatenation (e.g. "20" + 1 = "201")
    orderItem.quantity = Number(orderItem.quantity) || 0;

    if (key == "updateUpQty") {
      orderItem.quantity += 1;
      changeQuantity = 1;
    } else if (key == "updateDownQty" && orderItem.quantity > 0) {
      orderItem.quantity -= 1;
      changeQuantity = orderItem.productDto.isOverInventory ? 0 : -1;
    }

    changeQuantity !== 0 &&
      this.updateListPrice(orderItem.productDto, changeQuantity);
    orderItem.price = orderItem.quantity * orderItem.adjustedPrice; //* orderItem.unitPrice
    this.checkIsOverInventory(orderItem.productDto);
    this.bindingOrderCart();
    this.spinner.hide();
  }

  private toDateString(date: Date): string {
    return (
      date.getFullYear().toString() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2) +
      "T" +
      date.toTimeString().slice(0, 5)
    );
  }

  setInvoiceDefault() {
    this.orderCustomerModel.createdId = this.authService.getAccount().id;
    this.orderCustomerModel.orderChannel = OrderChanelEnum.BAN_TRUC_TIEP; //TODO
    this.orderCustomerModel.orderType = OrderTypeEnum.BAN_NHANH;
    this.orderCustomerModel.discount = 0;
    this.orderCustomerModel.orderTotal = 0;
    this.orderCustomerModel.price = 0;
    this.orderCustomerModel.quantity = 0;
    this.orderCustomerModel.payingAmtInvoice = 0;
    this.orderCustomerModel.orderItemCustomers = [];
    this.orderCustomerModel.paymentTypeEnum = PaymentTypeEnum.TIEN_MAT;
    this.orderCustomerTypeEnumCtrl.setValue(0);
    this.orderCustomerModel.orderCustomerTypeEnum =
      OrderCustomerTypeEnum.BAN_LE;
    this.isInvoiceByTime = false;
    this.orderDateCtrl.setValue(formatDateTimeZone(new Date()));
    this.customerCtrl.setValue(null);
    this.reloadCustomerComponent = new Date().getTime(); // Force refresh of customer search component
  }

  addCustomer() {
    const drawerRef = this.drawerService.open(AddCustomerDrawerComponent, {
      title: 'Thêm khách hàng',
      width: '90%',
      data: { mode: 'create' }
    });

    drawerRef.afterClosed().subscribe((x) => {
      if (x) {
        this.reloadCustomerComponent = x;
      }
    });
  }

  // getLstSuggestMoney() {
  //   let lstSuggestMoney = [];
  //   if (this.orderCustomerModel.orderTotal > 0) {
  //     this.lstSuggestMoney.forEach(x => {
  //       if (this.orderCustomerModel.orderTotal != x && this.orderCustomerModel.orderTotal > constant.VND_1000) {
  //         lstSuggestMoney.push(this.orderCustomerModel.orderTotal);
  //       } else if (this.orderCustomerModel.orderTotal < constant.VND_1000) {
  //         lstSuggestMoney = this.lstSuggestMoney;
  //       }
  //     })
  //   }
  // }

  validateOrder(): boolean {
    let valid = true;
    this.toggle();
    let checkIsOverInventory = this.orderCustomerModel.orderItemCustomers.some(
      (x) => x.productDto.isOverInventory,
    );
    let productOverInventory = this.orderCustomerModel.orderItemCustomers.find(
      (x) => x.productDto.isOverInventory,
    );
    if (checkIsOverInventory && !this.authService.getAccount().laKhachHang) {
      this.alertService.warning(
        `Có sản phẩm <strong>${productOverInventory.productName}</strong> đã vượt quá số lượng tồn kho, mời bạn kiểm tra lại`,
      );
      valid = false;
      return valid;
    }

    if (
      this.orderCustomerModel.orderTotal <= 0 ||
      this.orderCustomerModel.quantity <= 0 ||
      this.orderCustomerModel.orderItemCustomers.length == 0
    ) {
      this.alertService.warning("Hóa đơn thanh toán không hợp lệ");
      valid = false;
      return valid;
    }

    if (
      this.orderCustomerTypeEnumCtrl.value == OrderCustomerTypeEnum.BAN_LE &&
      this.orderCustomerModel.payingAmtInvoice -
      this.orderCustomerModel.orderTotal <
      0
    ) {
      this.alertService.warning("Số tiền thanh toán hóa đơn không hợp lệ");
      valid = false;
      return valid;
    }

    if (!this.accountCtrl.value) {
      this.alertService.warning("Người lập hóa đơn không hợp lệ");
      valid = false;
      return valid;
    }

    if (!this.orderDateCtrl.value) {
      this.alertService.warning("Ngày lập hóa đơn không hợp lệ");
      valid = false;
      return valid;
    }

    // Legacy check for safety or if other parts use it
    this.date = this.toDateString(new Date(this.orderDateCtrl.value));

    if (!this.customerCtrl.value) {
      this.alertService.warning("Bạn cần chọn khách hàng");
      valid = false;
      return valid;
    }

    return valid;
  }

  onSaveDraft() {
    let valid = this.validateOrder();

    if (!valid) {
      return;
    }

    this.orderCustomerModel.createdId = this.accountCtrl.value.id;
    this.alertService
      .confirm(
        "Bạn có chắc chắn muốn lưu tạm hóa đơn này không?",
        "Thanh toán hóa đơn",
      )
      .subscribe((x) => {
        if (x) {
          this.spinner.show();
          this.orderCustomerClient
            .create(
              this.requestOrder(
                this.authService.getAccount().laKhachHang
                  ? OrderCustomerStatusEnum.WAITING_ORDER_CONFIRM
                  : OrderCustomerStatusEnum.DRAFT,
              ),
            )
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe((z) => {
              this.alertService.success(
                "Thanh toán hóa đơn thành công",
                "Thanh toán hóa đơn",
              );
              this.setInvoiceDefault();
              this.eventEmitter.emitEvent(z);
            });
        }
      });
  }

  @Input() eventEmitter: EventEmitterService;

  onSave() {
    let valid = this.validateOrder();

    if (!valid) {
      return;
    }

    this.orderCustomerModel.createdId = this.accountCtrl.value.id;
    this.alertService
      .confirm(
        "Bạn có chắc chắn muốn in hóa đơn này không?",
        "Thanh toán hóa đơn",
      )
      .subscribe((x) => {
        if (x == true) {
          this.spinner.show();
          this.orderCustomerClient
            .create(this.requestOrder(OrderCustomerStatusEnum.DONE))
            .pipe(
              finalize(() => {
                this.spinner.hide();
              }),
            )
            .subscribe((z: any) => {
              this.alertService.success(
                "Thanh toán hóa đơn thành công",
                "Thanh toán hóa đơn",
              );
              var modelPrint = new PrintInvoicePdf();
              modelPrint.phone = "0961077031";
              modelPrint.customerName = this.customerCtrl.value
                ? this.customerCtrl.value.name
                : "Khách vãng lai";
              modelPrint.discount = this.orderCustomerModel.discount;
              modelPrint.orderTotalQty = this.orderCustomerModel.quantity;
              modelPrint.orderTotal = this.orderCustomerModel.orderTotal;
              modelPrint.time = moment(this.orderDateCtrl.value)
                .format("DD/MM/YYYY HH:mm");
              modelPrint.payingAmtInvoice =
                this.orderCustomerModel.payingAmtInvoice;
              modelPrint.code = z;
              modelPrint.sellerName = this.accountCtrl.value
                ? this.accountCtrl.value.fullName
                : "";

              if (this.paymentTypeCtrl.value == 0) {
                modelPrint.paymentType = "Tiền mặt";
              } else if (this.paymentTypeCtrl.value == 1) {
                modelPrint.paymentType = "Thẻ";
              } else if (this.paymentTypeCtrl.value == 2) {
                modelPrint.paymentType = "Chuyển khoản";
              } else {
                modelPrint.paymentType = "Chưa thanh toán";
              }

              this.eventEmitter.emitEvent(z);
              this.generatePDF(modelPrint);
              this.setInvoiceDefault();
            });
        } else if (x == false) {
          this.spinner.show();
          this.orderCustomerClient
            .create(this.requestOrder(OrderCustomerStatusEnum.DONE))
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe((z) => {
              this.alertService.success(
                "Thanh toán hóa đơn thành công",
                "Thanh toán hóa đơn",
              );
              this.setInvoiceDefault();
              this.eventEmitter.emitEvent(z);
            });
        }
      });
  }

  private requestOrder(status: number): OrderCustomerModel {
    return new OrderCustomerModel({
      createdId: this.orderCustomerModel.createdId,
      customerId: this.customerCtrl.value ? this.customerCtrl.value.id : null,
      discount: this.orderCustomerModel.discount,
      isUsingPrescription: this.orderCustomerModel.isUsingPrescription,
      orderChannel: this.orderCustomerModel.orderChannel,
      orderTime: moment.utc(this.orderDateCtrl.value).toDate(),
      orderTotal: this.orderCustomerModel.orderTotal,
      orderType: this.orderCustomerModel.orderType,
      price: this.orderCustomerModel.price,
      payingAmtInvoice: this.orderCustomerModel.payingAmtInvoice,
      quantity: this.orderCustomerModel.quantity,
      note: this.orderCustomerModel.note,
      paymentTypeEnum: this.paymentTypeCtrl.value,
      discountType: this.activeDiscountTypeVND
        ? DiscountTypeEnum.VND
        : DiscountTypeEnum.PERCENT,
      orderItemCustomers: this.orderCustomerModel.orderItemCustomers,
      status: status,
      isInvoiceByTime: this.createByTimeCtrl.value,
      orderCustomerTypeEnum: this.orderCustomerTypeEnumCtrl.value,
    });
  }

  exportState() {
    return {
      orderCustomerModel: JSON.parse(JSON.stringify(this.orderCustomerModel)),
      customer: this.customerCtrl.value,
      paymentType: this.paymentTypeCtrl.value,
      orderCustomerType: this.orderCustomerTypeEnumCtrl.value,
      createByTime: this.createByTimeCtrl.value,
      orderDate: this.orderDateCtrl.value,
    };
  }

  applyState(state: any) {
    if (!state) return;

    if (state.orderCustomerModel) {
      this.orderCustomerModel = OrderCustomerModel.fromJS(state.orderCustomerModel);
    }

    setTimeout(() => {
      if (state.customer) this.customerCtrl.setValue(state.customer);
      if (state.paymentType !== undefined)
        this.paymentTypeCtrl.setValue(state.paymentType);
      if (state.orderCustomerType !== undefined)
        this.orderCustomerTypeEnumCtrl.setValue(state.orderCustomerType);
      if (state.createByTime !== undefined)
        this.createByTimeCtrl.setValue(state.createByTime);
      if (state.orderDate) this.orderDateCtrl.setValue(state.orderDate);

      this.bindingOrderCart();
      this.updateProductHighlightColors();

      // Check inventory for all items after restore
      if (this.orderCustomerModel.orderItemCustomers) {
        this.orderCustomerModel.orderItemCustomers.forEach((item) => {
          if (item.productDto) {
            this.checkIsOverInventory(item.productDto);
          }
        });
      }

      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }, 0);
  }
}
